<template>
  <div class="text-right">
    <router-link :to="{name: url}" class="btn btn-sm btn-secondary wd-xs" type="submit">
      <span>{{ $t('button.cancel') }}</span>
    </router-link>
    <button class="btn btn-sm btn-success wd-xs" type="submit">{{ $t('button.save') }}</button>
  </div>
</template>

<script>
export default {
  props: {
    url: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Buttons.vue